//TODO that it should be placed in .env

export const PUBLIC_PREFIX = `public/uploads`

export const QUESTION_MEDIA_PATH_S3 = `${PUBLIC_PREFIX}/questionMedia`
export const DENTAL_SCHOOL_MEDIA_PATH_S3 = `${PUBLIC_PREFIX}/dentalSchoolMedia`
export const PRACTICE_TEST_MEDIA_PATH_S3 = `${PUBLIC_PREFIX}/practiceTestMedia`
export const USER_AVATAR_PATH_S3 = `${PUBLIC_PREFIX}/userAvatar`
export const BLOG_POST_MEDIA_PATH_S3 = `${PUBLIC_PREFIX}/blogPost`
export const STUDENT_AVATAR_PATH_S3 = `${PUBLIC_PREFIX}/success-story/userAvatar`
export const COMMON_ELEMENTS_PATH_S3 = `${PUBLIC_PREFIX}/common-elements`
export const PRODUCTS_PATH_S3 = `${PUBLIC_PREFIX}/products`
export const STRIPE_PRODUCT_IMAGES_PATH_S3 = `${PUBLIC_PREFIX}/stripe-images`
export const REWARDS_PATH_S3 = `${PUBLIC_PREFIX}/rewards`
export const INFLUENCER_HUB_PATH_S3 = `${PUBLIC_PREFIX}/influencer-hub`
export const MAX_AVAILABLE_FILES_TO_UPLOAD_AS_IMAGE = 1

export const IMAGE_DROPZONE_OPTIONS = {
  accept: {
    'image/*': [],
  },
}
